<template>
  <div class="rg-deselect-all-button-wrapper">
    <span class="aisea-text-12-400-white">{{ buttonText }}</span>
    <button class="rg-deselect-all-button" @click="deselectAll">
      <cross-icon class="rg-deselect-all-button-icon"></cross-icon>
    </button>
  </div>
</template>

<script>
import CrossIcon from "../icons/CrossIcon.vue";

export const EVENTS = {
  DESELECT_ALL: "deselect-all",
};

export default {
  name: "RgDeselectAllButton",

  components: {
    CrossIcon,
  },

  props: {
    buttonText: {
      type: String,
      default: "",
    },
  },

  methods: {
    deselectAll() {
      this.$emit(EVENTS.DESELECT_ALL);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_mixin.scss";
@import "@/assets/scss/aisea/_variables.scss";

.rg-deselect-all-button-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 22px;
  user-select: none;

  // reset button style
  button {
    background: none; /* Removes any default background */
    border: none; /* Removes any default border */
    padding: 0; /* Removes any default padding */
    cursor: pointer; /* Ensures the cursor changes to a pointer to indicate it's clickable */
  }

  .rg-deselect-all-button {
    width: fit-content;
    height: fit-content;
    border-radius: 24px;
    line-height: 0; // ボタンの高さをiconの高さに合わせる
  }

  .rg-deselect-all-button-icon {
    width: 22px;
    height: 22px;
    background-color: $aisea-gray-black;
    border-radius: 24px;

    &:hover {
      background-color: $aisea-gray;
    }

    &:active {
      background-color: $aisea-mouse-gray;
    }
  }
}
</style>
